import { FunctionComponent } from 'react';
import cn from 'classnames';

type SectionHeadingProps = {
  text: string;
  borderless?: boolean;
  className?: string;
  rightActionElement?: React.ReactNode;
};

export const SectionHeading: FunctionComponent<SectionHeadingProps> = ({
  text,
  borderless,
  className,
  rightActionElement,
}) => (
  <div
    className={cn(
      {
        'border-b': !borderless,
        'pb-4 flex items-center': !className,
      },
      className
    )}
  >
    <h1 className="flex-1 text-2xl font-bold leading-10 tracking-tight text-gray-900">
      {text}
    </h1>
    {rightActionElement}
  </div>
);

export default SectionHeading;
